// 原材料
<template>
  <div>
    <div
      class="bill-area"
      ref="bill"
      v-if="isDom"
      :style="{ width: fontSize(4.8) + 'px', height: fontSize(3) + 'px' }"
    >
      <p class="tit" :style="{ fontSize: fontSize(0.26) + 'px', lineHeight: fontSize(0.36) + 'px' }">{{ modelTypeObj[modelInfo.modelType] }}</p>
      <div class="info_box">
        <p class="item" :style="{ fontSize: fontSize(0.16) + 'px', lineHeight: fontSize(0.24) + 'px' }" v-for="(item, i) in modelColumn" :key="i">
          {{ item.label }}：{{ labelInfo[item.key] || "" }}
        </p>
      </div>
      <div class="code_box" id="qrCode" ref="qrCodeDiv"></div>
    </div>
    <!--  height: fontSize(3) + 'px'  -->
    <img v-else :style="{ width: fontSize(4.8) + 'px'}" :src="canvasImageUrl" alt="" />
    <!-- <div class="canvas-bill" v-else></div> -->
    <!-- <div class="save_btn" @click="htmlToCanvas">打印二维码图片</div> -->
  </div>
</template>

<script>
import axios from "axios";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  props: {
    labelInfo: {
      type: Object,
      default: {},
    },
    modelInfo: {
      type: Object,
      default: {
        modelType: 1,
      },
    },
  },
  name: "Home",
  data() {
    return {
      modelColumn: [],
      isDom: true,
      canvasImageUrl: "",
      ip: window.localStorage.getItem("ip") || "",
      modelTypeObj: {
        1: "原材料",
        2: "模具",
        3: "成品",
      },
    };
  },
  created() {
    console.log("labelInfo", this.labelInfo);
    console.log("modelInfo", this.modelInfo.modelType);
    console.log("modelColumn", this.modelColumn);
    this.modelColumn = JSON.parse(this.modelInfo.modelColumn);

    this.$nextTick(() => {
      new QRCode(this.$refs.qrCodeDiv, {
        // text: this.labelInfo.label_no,
        text: this.labelInfo.id,
        // width: this.fontSize(0.66),
        // height: this.fontSize(0.66),
        width: this.modelColumn.qrSize || this.fontSize(1.3),
        height: this.modelColumn.qrSize || this.fontSize(1.3),
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });

      // this.htmlToCanvas();
    });
  },
  mounted() {
    // // 二维码地址
    // this.qrcodeUrl = data.data.inviteCodeAddress;
    // 调用html转化canvas函数
    setTimeout(() => {
      this.htmlToCanvas();
    }, 1200);
  },
  methods: {
    fontSize(res) {
      let clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return;
      // let fontSize = 100 * (clientWidth / 1920);
      let fontSize = 100 * 1;
      return res * fontSize;
    },
    htmlToCanvas() {
      html2canvas(this.$refs.bill, {
        background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
        // dpi: 1080,
        scale: 2,
        // width: this.fontSize(4.8),
        // height: this.fontSize(3),
        style: {
          width: this.fontSize(4.8) + 'px',
          height: this.fontSize(3) + 'px',
        },
        scrollY: -18,
        scrollX: 10,
      }).then((canvas) => {
        let imageUrl = canvas.toDataURL("image/png"); // 将canvas转成base64图片格式
        this.canvasImageUrl = imageUrl;
        this.isDom = false;
        // this.onPrinter();

        // var alink = document.createElement("a");
        // alink.href = imageUrl;
        // alink.download = this.labelInfo.label_no; //fileName保存提示中用作预先填写的文件名
        // alink.click();
        // setTimeout(() => {
        //   this.$parent.onIn();
        // }, 3000);
      });
    },

    //1,先将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //2,再将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date(); // 文件最后的修改日期
      theBlob.name = fileName; // 文件名
      return new File([theBlob], fileName, {
        type: theBlob.type,
        lastModified: Date.now(),
      });
    },

    onPrinter() {
      // 1.先转为 blob格式  file.content是此文件的base64格式
      let blob = this.dataURLtoBlob(this.canvasImageUrl);
      // 拿到文件名
      let fileName = "";

      // 2，在转为 file类型
      let file1 = this.blobToFile(blob, fileName);
      console.log("file1:", file1);

      let formData = new FormData();
      formData.append("imgFile", file1 || new File([], "file"));
      formData.append("printName", "POSTEK E300 Series");
      //发送post请求
      axios
        .post("http://30.8.1.103:8555/yx/print/qrcode", formData)
        .then((res) => {
          if (res.data.status == 200) {
            setTimeout(() => {
              this.$parent.onIn();
            }, 3000);
            this.$message.success("打印成功");
          } else {
            this.$parent.onIn(2);
            this.$message.error("打印失败");
          }
        })
        .catch((err) => console.log(err));

      // setTimeout(() => {
      //   this.$parent.onIn();
      // }, 3000);

      // this.$api
      //   .printerImgPrint({
      //     // ip: this.ip,
      //     // fileBase64: this.canvasImageUrl,
      //     printName: "POSTEK E300 Series",
      //     imgFile: this.canvasImageUrl,
      //   })
      //   .then((res) => {
      //     if (res.status == 200) {
      //       if (res.data.status == 200) {
      //         // setTimeout(() => {
      //         //   this.$parent.onIn();
      //         // }, 3000);
      //         // this.$message.success("打印成功");
      //       } else {
      //         this.$parent.onIn(2);
      //         this.$message.error("打印失败");
      //       }
      //     } else {
      //       this.$message.error(res.message);
      //     }
      //   })
      //   .catch((err) => {
      //     this.$message.error(err.message);
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
.bill-area .info_box .item {
  line-height: 20px;
}
</style>
